
import React from 'react'
import MenuSelector from '../components/MenuSelector'
import NavbarWrapper from '../components/Navbar/NavbarWrapper'

function NewOrder() {
    return(
    <div>
        <NavbarWrapper /> 
        <MenuSelector />
    </div> 
    )
}

export default NewOrder